import { useParams } from 'react-router-dom';
import {
  getScheduleAction,
  getScheduleErrorsAction,
  scheduleActions,
  scheduleSelectors,
} from 'features/schedule/redux';
import { useBulkUpdateScheduleLessonsMutation } from 'shared/api';
import { useAppDispatch } from 'shared/services/redux/hooks/use-dispatch';
import { useAppSelector } from 'shared/services/redux/hooks/use-selector';
import type { SchedulePageParams } from 'services/navigation';

export const useEditModeToolbar = () => {
  const dispatch = useAppDispatch();
  const editMode = useAppSelector(scheduleSelectors.getEditMode);

  const { configurationId, scheduleId } = useParams<SchedulePageParams>();

  const [batchUpdateScheduleLessons, { isLoading: saveIsLoading }] =
    useBulkUpdateScheduleLessonsMutation();

  const changesCount = editMode ? Object.keys(editMode.changesByLessonId).length : 0;

  const handleCancelEditMode = () => {
    dispatch(scheduleActions.cancelEditMode());
  };

  const handleSaveEditMode = async () => {
    if (!editMode || !scheduleId || !configurationId) return;

    const changes = Object.values(editMode.changesByLessonId);

    await batchUpdateScheduleLessons({
      timetableId: scheduleId,
      changes,
    }).unwrap();

    dispatch(scheduleActions.finishEditMode());

    dispatch(
      getScheduleAction({
        curriculumId: configurationId,
        scheduleId,
        filters: {},
      }),
    );

    dispatch(
      getScheduleErrorsAction({
        configurationId,
        scheduleId,
        filters: {},
      }),
    );
  };

  return {
    state: {
      changesCount,
      saveIsLoading,
    },
    methods: {
      handleCancelEditMode,
      handleSaveEditMode,
    },
  };
};
